import { render } from "./SelectTenant.vue?vue&type=template&id=5ba12927&scoped=true&ts=true"
import script from "./SelectTenant.vue?vue&type=script&lang=ts"
export * from "./SelectTenant.vue?vue&type=script&lang=ts"

import "./SelectTenant.vue?vue&type=style&index=0&id=5ba12927&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba12927"]])

export default __exports__